import { useAnalytics } from 'hooks';
import React, { createContext, useEffect, useMemo, useState, } from 'react';
const ImpactClaimsContext = createContext(null);
const ImpactClaimsConsumer = ImpactClaimsContext.Consumer;
const ImpactClaimsProvider = ({ children, impactClaims }) => {
    const [selectedClaimId, setSelectedClaimId] = useState();
    const { trackActiveClaim } = useAnalytics();
    useEffect(() => {
        trackActiveClaim({
            impactClaimId: selectedClaimId,
        });
    }, [selectedClaimId]);
    const selectedClaim = useMemo(() => {
        var _a;
        return (_a = impactClaims === null || impactClaims === void 0 ? void 0 : impactClaims.edges.find((claim) => claim.node.id === selectedClaimId)) === null || _a === void 0 ? void 0 : _a.node;
    }, [selectedClaimId, impactClaims]);
    const toggleImpactClaim = (claimId) => {
        if (selectedClaimId === claimId) {
            // This claim is currently selected, unselect
            setSelectedClaimId(undefined);
        }
        else {
            // Set as selected
            setSelectedClaimId(claimId);
        }
    };
    const handleCloseClaim = () => {
        setSelectedClaimId(undefined);
    };
    return (React.createElement(ImpactClaimsContext.Provider, { value: {
            selectedClaim,
            selectedClaimId,
            toggleImpactClaim,
            impactClaims,
            handleCloseClaim,
            setSelectedClaimId,
        } }, children));
};
export { ImpactClaimsConsumer, ImpactClaimsProvider };
export default ImpactClaimsContext;
